export enum CountryCode {
  USA = 'US',
  CANADA = 'CA',
  JAPAN = 'JP',
  BRAZIL = 'BR',
}
